export var Messages = {
    Error: {
        ModelNotFound: 'error:modelNotFound'
    }
};
export var i18nMessages = {
    en: {
        translation: {
            error: {
                modelNotFound: 'The model with id "{{id}}" was not found in the model collection.'
            }
        }
    },
    es: {
        translation: {
            error: {
                modelNotFound: 'El modelo con identificador "{{id}}" no fue encontrado en la coleccion de modelos.'
            }
        }
    }
};
